<script setup lang="ts">
import { useAppStore } from '@/store';

const appStore = useAppStore();
const { isMobile, isOpenNav, isLoading } = storeToRefs(appStore);

const mini = ref(false);

const mainStyle = computed(() => ({
  '--v-layout-left': isMobile.value ? '0' : mini.value ? '56px' : '220px',
  '--v-layout-top': '50px',
}));

// keep-alive에 포함할 컴포넌트 이름 목록
const keepAliveInclude = computed(() => {
  const includeSet = new Set<string>();

  // 모든 라우트를 순회하며 keepAlive: true인 라우트의 name을 수집
  const collectKeepAliveRoutes = (routes: any[]) => {
    routes.forEach((route) => {
      if (route.meta?.keepAlive && route.name) {
        includeSet.add(route.name);
      }
      if (route.children) {
        collectKeepAliveRoutes(route.children);
      }
    });
  };

  // 현재 라우터의 모든 라우트를 확인
  const router = useRouter();
  collectKeepAliveRoutes(router.getRoutes());

  return Array.from(includeSet);
});
</script>

<template>
  <v-app>
    <AppSideNav v-model="mini" v-if="!isMobile || isOpenNav" />
    <v-main :style="mainStyle" class="d-flex flex-column" id="main`">
      <AppHeader />
      <div class="router-view-container">
        <router-view v-slot="{ Component }">
          <keep-alive :include="keepAliveInclude">
            <component :is="Component" v-if="Component" class="view" />
          </keep-alive>
        </router-view>
        <div class="loading-container loading-visible" @click.prevent.stop v-if="isLoading">
          <div class="loading-content d-flex justify-center align-center">
            <v-progress-circular indeterminate color="#c9c9c9" size="64"></v-progress-circular>
          </div>
        </div>
      </div>
    </v-main>
  </v-app>
</template>

<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
#main {
  width: 100%;
  height: 100%;
}
.router-view-container {
  flex: 1;
  position: relative;
  min-width: 1600px;
}
.view {
  padding: 30px;
  display: flex;
  flex-direction: column;
}

@keyframes loading-animation {
  0% {
    opacity: 0;
  }
  99% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.loading-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: -1000;

  &.loading-visible {
    z-index: 9999;
    pointer-events: auto; /* 로딩 중에만 클릭 차단 */
  }
}
.loading-content {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  animation: loading-animation 1s ease-in-out;
}
</style>
